import { connect } from 'react-redux';
import { fetchDeviation } from '../../redux/deviations/actionCreators';
import { getDeviationById } from '../../redux/deviations/selectors';
var mapStateToProps = function (state, props) { return ({
    deviation: getDeviationById(state, props.deviationId),
}); };
var mapDispatchToProps = {
    fetchDeviation: fetchDeviation,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=DeviationVideo.container.js.map